import React from "react";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import classNames from "classnames";

export type DSTooltipProps = TooltipProps & {
    baseClassName?: string;
};

const DSTooltip = ({
    children,
    baseClassName = "ds-tooltip__tooltip",
    className = "",
    ...props
}: DSTooltipProps) => (
    <Tooltip classes={{ tooltip: classNames(baseClassName, className) }} {...props}>
        {children}
    </Tooltip>
);

export const HTMLTooltip = (props: DSTooltipProps) => (
    <DSTooltip baseClassName="ds-html-tooltip__tooltip" {...props} />
);

export const RightTooltip = (props: DSTooltipProps) => <DSTooltip placement="right" {...props} />;

export default DSTooltip;
